'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatOfficeHoursWillReturnTimestamp = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _timestampIsToday = require('./timestampIsToday');

var _timestampIsTomorrow = require('./timestampIsTomorrow');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatOfficeHoursWillReturnTimestamp = exports.formatOfficeHoursWillReturnTimestamp = function formatOfficeHoursWillReturnTimestamp(timestamp) {
  var time = _I18n2.default.moment.userTz(timestamp);
  var formattedTime = time.format('LT');

  if ((0, _timestampIsToday.timestampIsToday)(timestamp)) {
    return _I18n2.default.text('conversationsVisitorUIAvailability.sameDay', {
      time: formattedTime
    });
  }

  if ((0, _timestampIsTomorrow.timestampIsTomorrow)(timestamp)) {
    return _I18n2.default.text('conversationsVisitorUIAvailability.nextDay', {
      time: formattedTime
    });
  }

  return _I18n2.default.text('conversationsVisitorUIAvailability.nextWeek', {
    dayOfWeek: _I18n2.default.moment.weekdays(true, time.weekday()),
    time: formattedTime
  });
};